import React from 'react';
import { MapPin, Mail, Phone, Linkedin, Github, Star, ExternalLink, Building2, GraduationCap, Code, Award, Share2, MessageSquare, Edit, Users, Briefcase, FileText, Globe, Calendar, TrendingUp } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { Progress } from '../components/ui/Progress';
import { Avatar, AvatarFallback, AvatarImage } from '../components/ui/Avatar';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
export function ProfilePage() {
  const {
    user
  } = useAuth();
  const navigate = useNavigate();
  // Render berbeda berdasarkan jenis keanggotaan
  const isIndividu = user?.role === 'anggota_individu';
  const isOrganisasi = user?.role === 'anggota_organisasi';
  const isBadanUsaha = user?.role === 'anggota_badan_usaha';
  const isMitra = user?.role === 'mitra_asosiasi';
  return <div className="min-h-screen bg-white pb-12" data-id="element-4239">
      {/* Header Section */}
      <div className="relative" data-id="element-4240">
        {/* Cover Image */}
        <div className="h-48 w-full bg-gradient-to-r from-neutral-50 to-neutral-100 border-b border-neutral-200" data-id="element-4241">
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=2070&auto=format&fit=crop')] bg-cover bg-center opacity-5" data-id="element-4242"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4243">
          <div className="relative -mt-16 mb-8 flex flex-col md:flex-row items-end md:items-center gap-6" data-id="element-4244">
            <Avatar size="xl" className="border-4 border-white shadow-md" data-id="element-4245">
              <AvatarImage src={isIndividu ? 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80' : undefined} data-id="element-4246" />
              <AvatarFallback data-id="element-4247">{user?.avatar || 'U'}</AvatarFallback>
            </Avatar>

            <div className="flex-1 pt-4 md:pt-0" data-id="element-4248">
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-4249">
                <div data-id="element-4250">
                  <h1 className="text-3xl font-semibold text-neutral-900 mb-1" data-id="element-4251">
                    {user?.nama || (isIndividu ? 'John Doe' : user?.namaOrganisasi || 'Nama Organisasi')}
                  </h1>
                  <p className="text-neutral-600 text-base mb-2" data-id="element-4252">
                    {isIndividu && 'Senior Backend Developer'}
                    {isOrganisasi && 'Organisasi Pendidikan - Teknologi Informasi'}
                    {isBadanUsaha && 'Badan Usaha Kecil - Software Development'}
                    {isMitra && 'Mitra Strategis - Technology Partnership'}
                  </p>
                  <div className="flex flex-wrap items-center gap-4 text-sm text-neutral-600" data-id="element-4253">
                    <div className="flex items-center gap-1" data-id="element-4254">
                      <MapPin className="w-4 h-4" data-id="element-4255" />
                      {user?.kota || 'Jakarta'}, Indonesia
                    </div>
                    <Badge variant="success" data-id="element-4256">
                      {user?.nomorAnggota || 'ATI-2025-001234'}
                    </Badge>
                    {isIndividu && <div className="flex items-center gap-1 text-atios-primary" data-id="element-4257">
                        <Star className="w-4 h-4 fill-current" data-id="element-4258" />
                        <span className="font-medium" data-id="element-4259">4.8/5</span>
                      </div>}
                  </div>
                </div>

                <div className="flex gap-3" data-id="element-4260">
                  <Button variant="primary" onClick={() => navigate('/profile/edit')} data-id="element-4261">
                    <Edit className="w-4 h-4 mr-2" data-id="element-4262" />
                    Ubah Profil
                  </Button>
                  <Button variant="secondary" data-id="element-4263">
                    <Share2 className="w-4 h-4 mr-2" data-id="element-4264" /> Bagikan
                  </Button>
                  {isIndividu && <Button variant="secondary" data-id="element-4265">
                      <MessageSquare className="w-4 h-4 mr-2" data-id="element-4266" /> Pesan
                    </Button>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4267">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8" data-id="element-4268">
          {/* Left Sidebar */}
          <div className="space-y-6" data-id="element-4269">
            {/* Quick Info */}
            <Card data-id="element-4270">
              <CardContent className="p-6 space-y-4" data-id="element-4271">
                <div className="space-y-2" data-id="element-4272">
                  <p className="text-sm text-neutral-500" data-id="element-4273">Anggota Sejak</p>
                  <p className="font-medium text-neutral-900" data-id="element-4274">
                    {user?.tanggalBergabung || '1 Januari 2025'}
                  </p>
                </div>
                <div className="space-y-2" data-id="element-4275">
                  <p className="text-sm text-neutral-500" data-id="element-4276">Status</p>
                  <Badge variant="success" data-id="element-4277">
                    {user?.statusKeanggotaan || 'Active'}
                  </Badge>
                </div>
                {!isMitra && <div className="space-y-2" data-id="element-4278">
                    <p className="text-sm text-neutral-500" data-id="element-4279">Chapter</p>
                    <p className="font-medium text-neutral-900" data-id="element-4280">
                      {user?.namaChapter || 'Jakarta Tech Community'}
                    </p>
                  </div>}
                <div className="space-y-2" data-id="element-4281">
                  <p className="text-sm text-neutral-500" data-id="element-4282">Jenis Keanggotaan</p>
                  <p className="font-medium text-neutral-900" data-id="element-4283">
                    {isIndividu && 'Individu (Profesional)'}
                    {isOrganisasi && 'Organisasi (Pendidikan)'}
                    {isBadanUsaha && 'Badan Usaha (Kecil)'}
                    {isMitra && 'Mitra Asosiasi'}
                  </p>
                </div>
                <div className="space-y-2" data-id="element-4284">
                  <p className="text-sm text-neutral-500" data-id="element-4285">Masa Berlaku</p>
                  <p className="font-medium text-neutral-900" data-id="element-4286">
                    {user?.tanggalBerakhir || '31 Desember 2025'}
                  </p>
                </div>
                {(isOrganisasi || isBadanUsaha) && <div className="space-y-2" data-id="element-4287">
                    <p className="text-sm text-neutral-500" data-id="element-4288">Iuran Tahunan</p>
                    <p className="font-medium text-atios-primary" data-id="element-4289">
                      Rp{' '}
                      {user?.iuranTahunan?.toLocaleString('id-ID') || '5.000.000'}
                    </p>
                  </div>}
              </CardContent>
            </Card>

            {/* Contact Info */}
            <Card data-id="element-4290">
              <CardContent className="p-6 space-y-4" data-id="element-4291">
                <h3 className="font-semibold text-neutral-900 border-b border-neutral-200 pb-2 mb-2" data-id="element-4292">
                  Kontak
                </h3>
                <a href={`mailto:${user?.email}`} className="flex items-center gap-3 text-neutral-700 hover:text-atios-primary transition-colors" data-id="element-4293">
                  <Mail className="w-4 h-4" data-id="element-4294" />
                  <span className="text-sm" data-id="element-4295">
                    {user?.email || 'contact@example.com'}
                  </span>
                </a>
                <a href={`tel:${user?.telepon}`} className="flex items-center gap-3 text-neutral-700 hover:text-atios-primary transition-colors" data-id="element-4296">
                  <Phone className="w-4 h-4" data-id="element-4297" />
                  <span className="text-sm" data-id="element-4298">
                    {user?.telepon || '+62 812 3456 7890'}
                  </span>
                </a>
                {isIndividu && <>
                    <a href="#" className="flex items-center gap-3 text-neutral-700 hover:text-atios-primary transition-colors" data-id="element-4299">
                      <Linkedin className="w-4 h-4" data-id="element-4300" />
                      <span className="text-sm" data-id="element-4301">linkedin.com/in/johndoe</span>
                    </a>
                    <a href="#" className="flex items-center gap-3 text-neutral-700 hover:text-atios-primary transition-colors" data-id="element-4302">
                      <Github className="w-4 h-4" data-id="element-4303" />
                      <span className="text-sm" data-id="element-4304">github.com/johndoe</span>
                    </a>
                  </>}
                {(isOrganisasi || isBadanUsaha || isMitra) && <a href="#" className="flex items-center gap-3 text-neutral-700 hover:text-atios-primary transition-colors" data-id="element-4305">
                    <Globe className="w-4 h-4" data-id="element-4306" />
                    <span className="text-sm" data-id="element-4307">www.example.com</span>
                  </a>}
              </CardContent>
            </Card>

            {/* Stats for Organisasi/Badan Usaha */}
            {(isOrganisasi || isBadanUsaha) && <Card data-id="element-4308">
                <CardContent className="p-6 space-y-4" data-id="element-4309">
                  <h3 className="font-semibold text-neutral-900 border-b border-neutral-200 pb-2 mb-2" data-id="element-4310">
                    Statistik
                  </h3>
                  <div className="space-y-2" data-id="element-4311">
                    <p className="text-sm text-neutral-500" data-id="element-4312">
                      Anggota Terdaftar
                    </p>
                    <p className="font-medium text-neutral-900 text-2xl" data-id="element-4313">24</p>
                  </div>
                  <div className="space-y-2" data-id="element-4314">
                    <p className="text-sm text-neutral-500" data-id="element-4315">Lowongan Aktif</p>
                    <p className="font-medium text-neutral-900 text-2xl" data-id="element-4316">5</p>
                  </div>
                  <div className="space-y-2" data-id="element-4317">
                    <p className="text-sm text-neutral-500" data-id="element-4318">
                      Acara Diselenggarakan
                    </p>
                    <p className="font-medium text-neutral-900 text-2xl" data-id="element-4319">12</p>
                  </div>
                </CardContent>
              </Card>}
          </div>

          {/* Main Content */}
          <div className="lg:col-span-3 space-y-8" data-id="element-4320">
            {/* INDIVIDU CONTENT */}
            {isIndividu && <>
                {/* About */}
                <Card data-id="element-4321">
                  <CardHeader className="flex flex-row items-center justify-between" data-id="element-4322">
                    <CardTitle data-id="element-4323">Tentang</CardTitle>
                    <Button variant="link" className="text-atios-primary h-auto p-0" data-id="element-4324">
                      Ubah
                    </Button>
                  </CardHeader>
                  <CardContent data-id="element-4325">
                    <p className="text-neutral-700 leading-relaxed" data-id="element-4326">
                      Backend developer yang passionate dengan pengalaman 5+
                      tahun dalam membangun aplikasi web yang scalable.
                      Spesialisasi di Node.js, Python, dan arsitektur cloud.
                      Berkomitmen untuk menulis kode yang clean dan maintainable
                      serta membangun lingkungan pengembangan yang kolaboratif.
                    </p>
                  </CardContent>
                </Card>

                {/* Skills */}
                <Card data-id="element-4327">
                  <CardHeader data-id="element-4328">
                    <CardTitle data-id="element-4329">Keahlian</CardTitle>
                  </CardHeader>
                  <CardContent data-id="element-4330">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-4331">
                      {[{
                    name: 'Backend Development',
                    level: 'Ahli',
                    percent: 95,
                    endorsed: 23
                  }, {
                    name: 'Node.js',
                    level: 'Mahir',
                    percent: 85,
                    endorsed: 18
                  }, {
                    name: 'PostgreSQL',
                    level: 'Mahir',
                    percent: 80,
                    endorsed: 15
                  }, {
                    name: 'Docker',
                    level: 'Menengah',
                    percent: 70,
                    endorsed: 12
                  }, {
                    name: 'React',
                    level: 'Menengah',
                    percent: 65,
                    endorsed: 8
                  }, {
                    name: 'AWS',
                    level: 'Menengah',
                    percent: 60,
                    endorsed: 10
                  }].map((skill, i) => <div key={i} className="bg-neutral-50 p-4 rounded-lg border border-neutral-200 hover:border-atios-primary transition-colors" data-id="element-4332">
                          <div className="flex justify-between items-start mb-2" data-id="element-4333">
                            <h4 className="font-medium text-neutral-900" data-id="element-4334">
                              {skill.name}
                            </h4>
                            <Button variant="secondary" size="sm" className="h-7 px-2 text-xs" data-id="element-4335">
                              Dukung
                            </Button>
                          </div>
                          <div className="space-y-2" data-id="element-4336">
                            <div className="flex justify-between text-xs text-neutral-600" data-id="element-4337">
                              <span data-id="element-4338">{skill.level}</span>
                              <span data-id="element-4339">{skill.endorsed} dukungan</span>
                            </div>
                            <Progress value={skill.percent} className="h-1.5" data-id="element-4340" />
                          </div>
                        </div>)}
                    </div>
                  </CardContent>
                </Card>

                {/* Work Experience */}
                <Card data-id="element-4341">
                  <CardHeader data-id="element-4342">
                    <CardTitle data-id="element-4343">Pengalaman Kerja</CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-8" data-id="element-4344">
                    {[{
                  company: 'PT Teknologi Indonesia',
                  role: 'Senior Backend Developer',
                  period: 'Jan 2022 - Sekarang',
                  duration: '2 tahun',
                  desc: 'Memimpin tim backend development, merancang arsitektur microservices, dan mengoptimalkan performa database.',
                  stack: ['Node.js', 'PostgreSQL', 'Docker', 'Redis']
                }, {
                  company: 'PT Digital Solutions',
                  role: 'Backend Developer',
                  period: 'Jun 2019 - Des 2021',
                  duration: '2.5 tahun',
                  desc: 'Mengembangkan RESTful API, integrasi layanan pihak ketiga, dan maintenance codebase legacy.',
                  stack: ['Python', 'Django', 'MySQL']
                }].map((job, i) => <div key={i} className="relative pl-8 border-l-2 border-neutral-200 last:border-0" data-id="element-4345">
                        <div className="absolute -left-[9px] top-0 w-4 h-4 rounded-full bg-atios-primary border-4 border-white" data-id="element-4346"></div>
                        <div className="space-y-2" data-id="element-4347">
                          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2" data-id="element-4348">
                            <h3 className="text-base font-semibold text-neutral-900" data-id="element-4349">
                              {job.role}
                            </h3>
                            <span className="text-sm text-neutral-600 bg-neutral-100 px-2 py-1 rounded" data-id="element-4350">
                              {job.period} ({job.duration})
                            </span>
                          </div>
                          <div className="flex items-center gap-2 text-atios-primary" data-id="element-4351">
                            <Building2 className="w-4 h-4" data-id="element-4352" />
                            <span className="font-medium text-sm" data-id="element-4353">
                              {job.company}
                            </span>
                          </div>
                          <p className="text-neutral-700 text-sm leading-relaxed" data-id="element-4354">
                            {job.desc}
                          </p>
                          <div className="flex flex-wrap gap-2 pt-2" data-id="element-4355">
                            {job.stack.map(tech => <Badge key={tech} variant="default" className="text-xs" data-id="element-4356">
                                {tech}
                              </Badge>)}
                          </div>
                        </div>
                      </div>)}
                  </CardContent>
                </Card>

                {/* Education */}
                <Card data-id="element-4357">
                  <CardHeader data-id="element-4358">
                    <CardTitle data-id="element-4359">Pendidikan</CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-6" data-id="element-4360">
                    <div className="flex gap-4" data-id="element-4361">
                      <div className="h-12 w-12 rounded-lg bg-atios-light flex items-center justify-center text-atios-primary flex-shrink-0" data-id="element-4362">
                        <GraduationCap className="w-6 h-6" data-id="element-4363" />
                      </div>
                      <div data-id="element-4364">
                        <h3 className="text-base font-semibold text-neutral-900" data-id="element-4365">
                          Universitas Indonesia
                        </h3>
                        <p className="text-atios-primary text-sm" data-id="element-4366">
                          Sarjana Ilmu Komputer
                        </p>
                        <p className="text-sm text-neutral-600 mt-1" data-id="element-4367">
                          2015 - 2019 • IPK: 3.8/4.0
                        </p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </>}

            {/* ORGANISASI CONTENT */}
            {isOrganisasi && <>
                {/* Tentang Organisasi */}
                <Card data-id="element-4368">
                  <CardHeader data-id="element-4369">
                    <CardTitle data-id="element-4370">Tentang Organisasi</CardTitle>
                  </CardHeader>
                  <CardContent data-id="element-4371">
                    <p className="text-neutral-700 leading-relaxed mb-4" data-id="element-4372">
                      PT Tech Indonesia adalah organisasi pendidikan yang fokus
                      pada pengembangan talenta teknologi informasi di
                      Indonesia. Kami menyediakan program pelatihan,
                      sertifikasi, dan pengembangan karir untuk mahasiswa dan
                      profesional IT.
                    </p>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 pt-4 border-t border-neutral-200" data-id="element-4373">
                      <div data-id="element-4374">
                        <p className="text-sm text-neutral-500 mb-1" data-id="element-4375">
                          Didirikan
                        </p>
                        <p className="font-semibold text-neutral-900" data-id="element-4376">2015</p>
                      </div>
                      <div data-id="element-4377">
                        <p className="text-sm text-neutral-500 mb-1" data-id="element-4378">
                          Karyawan
                        </p>
                        <p className="font-semibold text-neutral-900" data-id="element-4379">50-100</p>
                      </div>
                      <div data-id="element-4380">
                        <p className="text-sm text-neutral-500 mb-1" data-id="element-4381">
                          Industri
                        </p>
                        <p className="font-semibold text-neutral-900" data-id="element-4382">
                          Pendidikan
                        </p>
                      </div>
                      <div data-id="element-4383">
                        <p className="text-sm text-neutral-500 mb-1" data-id="element-4384">Lokasi</p>
                        <p className="font-semibold text-neutral-900" data-id="element-4385">
                          Jakarta
                        </p>
                      </div>
                    </div>
                  </CardContent>
                </Card>

                {/* Program & Layanan */}
                <Card data-id="element-4386">
                  <CardHeader data-id="element-4387">
                    <CardTitle data-id="element-4388">Program & Layanan</CardTitle>
                  </CardHeader>
                  <CardContent data-id="element-4389">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-4390">
                      {[{
                    title: 'Pelatihan Bootcamp',
                    desc: 'Program intensif 12 minggu untuk fresh graduate',
                    icon: Code
                  }, {
                    title: 'Sertifikasi Profesional',
                    desc: 'Sertifikasi internasional untuk profesional IT',
                    icon: Award
                  }, {
                    title: 'Career Development',
                    desc: 'Bimbingan karir dan job placement',
                    icon: TrendingUp
                  }, {
                    title: 'Corporate Training',
                    desc: 'Pelatihan korporat untuk perusahaan',
                    icon: Building2
                  }].map((program, i) => <div key={i} className="flex gap-4 p-4 rounded-lg border border-neutral-200 hover:border-atios-primary transition-colors" data-id="element-4391">
                          <div className="h-12 w-12 rounded-lg bg-atios-light flex items-center justify-center text-atios-primary flex-shrink-0" data-id="element-4392">
                            <program.icon className="w-6 h-6" data-id="element-4393" />
                          </div>
                          <div data-id="element-4394">
                            <h4 className="font-semibold text-neutral-900 mb-1" data-id="element-4395">
                              {program.title}
                            </h4>
                            <p className="text-sm text-neutral-600" data-id="element-4396">
                              {program.desc}
                            </p>
                          </div>
                        </div>)}
                    </div>
                  </CardContent>
                </Card>

                {/* Anggota Terdaftar */}
                <Card data-id="element-4397">
                  <CardHeader data-id="element-4398">
                    <CardTitle data-id="element-4399">Anggota Terdaftar (24 orang)</CardTitle>
                  </CardHeader>
                  <CardContent data-id="element-4400">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-4401">
                      {Array.from({
                    length: 8
                  }).map((_, i) => <div key={i} className="flex flex-col items-center p-4 rounded-lg border border-neutral-200 hover:border-atios-primary transition-colors" data-id="element-4402">
                          <Avatar size="md" className="mb-2" data-id="element-4403">
                            <AvatarFallback data-id="element-4404">M{i + 1}</AvatarFallback>
                          </Avatar>
                          <p className="text-sm font-medium text-neutral-900 text-center" data-id="element-4405">
                            Member {i + 1}
                          </p>
                          <p className="text-xs text-neutral-500" data-id="element-4406">Developer</p>
                        </div>)}
                    </div>
                    <div className="text-center mt-4" data-id="element-4407">
                      <Button variant="secondary" data-id="element-4408">Lihat Semua Anggota</Button>
                    </div>
                  </CardContent>
                </Card>
              </>}

            {/* BADAN USAHA CONTENT */}
            {isBadanUsaha && <>
                {/* Tentang Perusahaan */}
                <Card data-id="element-4409">
                  <CardHeader data-id="element-4410">
                    <CardTitle data-id="element-4411">Tentang Perusahaan</CardTitle>
                  </CardHeader>
                  <CardContent data-id="element-4412">
                    <p className="text-neutral-700 leading-relaxed mb-4" data-id="element-4413">
                      CV Digital Solutions adalah perusahaan software
                      development yang fokus pada pembuatan aplikasi web dan
                      mobile untuk UMKM. Kami membantu bisnis kecil dan menengah
                      untuk digitalisasi dan meningkatkan efisiensi operasional.
                    </p>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 pt-4 border-t border-neutral-200" data-id="element-4414">
                      <div data-id="element-4415">
                        <p className="text-sm text-neutral-500 mb-1" data-id="element-4416">
                          Didirikan
                        </p>
                        <p className="font-semibold text-neutral-900" data-id="element-4417">2018</p>
                      </div>
                      <div data-id="element-4418">
                        <p className="text-sm text-neutral-500 mb-1" data-id="element-4419">
                          Karyawan
                        </p>
                        <p className="font-semibold text-neutral-900" data-id="element-4420">15-25</p>
                      </div>
                      <div data-id="element-4421">
                        <p className="text-sm text-neutral-500 mb-1" data-id="element-4422">
                          Kategori
                        </p>
                        <p className="font-semibold text-neutral-900" data-id="element-4423">
                          Usaha Kecil
                        </p>
                      </div>
                      <div data-id="element-4424">
                        <p className="text-sm text-neutral-500 mb-1" data-id="element-4425">Lokasi</p>
                        <p className="font-semibold text-neutral-900" data-id="element-4426">
                          Bandung
                        </p>
                      </div>
                    </div>
                  </CardContent>
                </Card>

                {/* Produk & Layanan */}
                <Card data-id="element-4427">
                  <CardHeader data-id="element-4428">
                    <CardTitle data-id="element-4429">Produk & Layanan</CardTitle>
                  </CardHeader>
                  <CardContent data-id="element-4430">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-4431">
                      {[{
                    title: 'Web Development',
                    desc: 'Pembuatan website company profile dan e-commerce',
                    icon: Code
                  }, {
                    title: 'Mobile Apps',
                    desc: 'Aplikasi Android dan iOS untuk bisnis',
                    icon: Briefcase
                  }, {
                    title: 'System Integration',
                    desc: 'Integrasi sistem dan API development',
                    icon: Globe
                  }, {
                    title: 'Maintenance & Support',
                    desc: 'Maintenance dan technical support',
                    icon: Users
                  }].map((service, i) => <div key={i} className="flex gap-4 p-4 rounded-lg border border-neutral-200 hover:border-atios-primary transition-colors" data-id="element-4432">
                          <div className="h-12 w-12 rounded-lg bg-atios-light flex items-center justify-center text-atios-primary flex-shrink-0" data-id="element-4433">
                            <service.icon className="w-6 h-6" data-id="element-4434" />
                          </div>
                          <div data-id="element-4435">
                            <h4 className="font-semibold text-neutral-900 mb-1" data-id="element-4436">
                              {service.title}
                            </h4>
                            <p className="text-sm text-neutral-600" data-id="element-4437">
                              {service.desc}
                            </p>
                          </div>
                        </div>)}
                    </div>
                  </CardContent>
                </Card>

                {/* Lowongan Kerja Aktif */}
                <Card data-id="element-4438">
                  <CardHeader data-id="element-4439">
                    <CardTitle data-id="element-4440">Lowongan Kerja Aktif (5)</CardTitle>
                  </CardHeader>
                  <CardContent data-id="element-4441">
                    <div className="space-y-4" data-id="element-4442">
                      {[{
                    title: 'Frontend Developer',
                    type: 'Full-time',
                    salary: 'Rp 8-12 juta',
                    applicants: 15
                  }, {
                    title: 'Backend Developer',
                    type: 'Full-time',
                    salary: 'Rp 10-15 juta',
                    applicants: 23
                  }, {
                    title: 'UI/UX Designer',
                    type: 'Contract',
                    salary: 'Rp 7-10 juta',
                    applicants: 8
                  }].map((job, i) => <div key={i} className="flex items-center justify-between p-4 rounded-lg border border-neutral-200 hover:border-atios-primary transition-colors" data-id="element-4443">
                          <div data-id="element-4444">
                            <h4 className="font-semibold text-neutral-900 mb-1" data-id="element-4445">
                              {job.title}
                            </h4>
                            <div className="flex items-center gap-3 text-sm text-neutral-600" data-id="element-4446">
                              <Badge variant="default" className="text-xs" data-id="element-4447">
                                {job.type}
                              </Badge>
                              <span data-id="element-4448">{job.salary}</span>
                              <span data-id="element-4449">{job.applicants} pelamar</span>
                            </div>
                          </div>
                          <Button variant="secondary" size="sm" data-id="element-4450">
                            Kelola
                          </Button>
                        </div>)}
                    </div>
                    <div className="text-center mt-4" data-id="element-4451">
                      <Button variant="secondary" data-id="element-4452">Lihat Semua Lowongan</Button>
                    </div>
                  </CardContent>
                </Card>
              </>}

            {/* MITRA ASOSIASI CONTENT */}
            {isMitra && <>
                {/* Tentang Mitra */}
                <Card data-id="element-4453">
                  <CardHeader data-id="element-4454">
                    <CardTitle data-id="element-4455">Tentang Mitra</CardTitle>
                  </CardHeader>
                  <CardContent data-id="element-4456">
                    <p className="text-neutral-700 leading-relaxed mb-4" data-id="element-4457">
                      Tech Partner Corp adalah mitra strategis ATIOS dalam
                      pengembangan ekosistem teknologi di Indonesia. Kami
                      berkolaborasi dalam berbagai program pelatihan,
                      sertifikasi, dan pengembangan komunitas teknologi.
                    </p>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 pt-4 border-t border-neutral-200" data-id="element-4458">
                      <div data-id="element-4459">
                        <p className="text-sm text-neutral-500 mb-1" data-id="element-4460">
                          Jenis Kemitraan
                        </p>
                        <p className="font-semibold text-neutral-900" data-id="element-4461">
                          Strategis
                        </p>
                      </div>
                      <div data-id="element-4462">
                        <p className="text-sm text-neutral-500 mb-1" data-id="element-4463">Sejak</p>
                        <p className="font-semibold text-neutral-900" data-id="element-4464">2025</p>
                      </div>
                      <div data-id="element-4465">
                        <p className="text-sm text-neutral-500 mb-1" data-id="element-4466">
                          Status MoU
                        </p>
                        <Badge variant="success" data-id="element-4467">Aktif</Badge>
                      </div>
                      <div data-id="element-4468">
                        <p className="text-sm text-neutral-500 mb-1" data-id="element-4469">
                          Masa Berlaku
                        </p>
                        <p className="font-semibold text-neutral-900" data-id="element-4470">2026</p>
                      </div>
                    </div>
                  </CardContent>
                </Card>

                {/* Program Kolaborasi */}
                <Card data-id="element-4471">
                  <CardHeader data-id="element-4472">
                    <CardTitle data-id="element-4473">Program Kolaborasi</CardTitle>
                  </CardHeader>
                  <CardContent data-id="element-4474">
                    <div className="space-y-4" data-id="element-4475">
                      {[{
                    title: 'Webinar Series',
                    desc: 'Webinar bulanan tentang teknologi terkini',
                    status: 'Aktif',
                    participants: 500
                  }, {
                    title: 'Certification Program',
                    desc: 'Program sertifikasi bersama',
                    status: 'Aktif',
                    participants: 150
                  }, {
                    title: 'Hackathon 2025',
                    desc: 'Kompetisi pengembangan aplikasi',
                    status: 'Upcoming',
                    participants: 200
                  }].map((program, i) => <div key={i} className="flex items-start justify-between p-4 rounded-lg border border-neutral-200" data-id="element-4476">
                          <div className="flex-1" data-id="element-4477">
                            <div className="flex items-center gap-2 mb-2" data-id="element-4478">
                              <h4 className="font-semibold text-neutral-900" data-id="element-4479">
                                {program.title}
                              </h4>
                              <Badge variant={program.status === 'Aktif' ? 'success' : 'default'} className="text-xs" data-id="element-4480">
                                {program.status}
                              </Badge>
                            </div>
                            <p className="text-sm text-neutral-600 mb-2" data-id="element-4481">
                              {program.desc}
                            </p>
                            <p className="text-xs text-neutral-500" data-id="element-4482">
                              {program.participants} peserta
                            </p>
                          </div>
                          <Button variant="secondary" size="sm" data-id="element-4483">
                            Detail
                          </Button>
                        </div>)}
                    </div>
                  </CardContent>
                </Card>

                {/* Dokumen MoU */}
                <Card data-id="element-4484">
                  <CardHeader data-id="element-4485">
                    <CardTitle data-id="element-4486">Dokumen Kemitraan</CardTitle>
                  </CardHeader>
                  <CardContent data-id="element-4487">
                    <div className="space-y-3" data-id="element-4488">
                      {[{
                    name: 'Memorandum of Understanding (MoU)',
                    date: '1 Jan 2025',
                    size: '2.5 MB'
                  }, {
                    name: 'Proposal Kolaborasi',
                    date: '15 Des 2024',
                    size: '1.8 MB'
                  }, {
                    name: 'Laporan Kegiatan Q1 2025',
                    date: '31 Mar 2025',
                    size: '3.2 MB'
                  }].map((doc, i) => <div key={i} className="flex items-center justify-between p-4 rounded-lg border border-neutral-200 hover:border-atios-primary transition-colors" data-id="element-4489">
                          <div className="flex items-center gap-3" data-id="element-4490">
                            <FileText className="w-5 h-5 text-atios-primary" data-id="element-4491" />
                            <div data-id="element-4492">
                              <p className="font-medium text-neutral-900 text-sm" data-id="element-4493">
                                {doc.name}
                              </p>
                              <p className="text-xs text-neutral-500" data-id="element-4494">
                                {doc.date} • {doc.size}
                              </p>
                            </div>
                          </div>
                          <Button variant="ghost" size="sm" data-id="element-4495">
                            <ExternalLink className="w-4 h-4" data-id="element-4496" />
                          </Button>
                        </div>)}
                    </div>
                  </CardContent>
                </Card>
              </>}
          </div>
        </div>
      </div>
    </div>;
}